import React, { Component } from 'react'
import DivisionesAbm from './DivisionesAbm'
import { Route, Switch } from 'react-router-dom'
import {FormattedMessage, injectIntl} from 'react-intl';
import DivisionesGrid from './DivisionesGrid'

class GestionDivisiones extends Component {
	render() {
		return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
	  					<h3 className="content-header-title"><FormattedMessage id="Administración_de_motivos_de_cambio_de_turno" defaultMessage="Administración de Gestión de Divisiones"/></h3>
	  				</div>
				</div>
				<div className="content-body">								
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={DivisionesGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(props) => <DivisionesAbm {...props} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/edit`} render={(props) => <DivisionesAbm {...props} action="EDIT" />} />
						<Route path={`${this.props.match.url}/:id`} render={(props) => <DivisionesAbm {...props} action="VIEW" />} />
					</Switch>										
				</div>
			</div>
		);
  	}
}

export default GestionDivisiones;